export default __webpack_public_path__ + "static/media/VOLKSWAGEN.50cca823.png";